/* LOOKBOOK 26AW: ルックのモーダル(sections/callec-lookbook.liquid) */
(() => {
  // 計測: Shopify.analytics.publish → カスタムピクセル callec-collection-events → GA4(2026-10-12)
  // テーマから gtag / dataLayer に送っても GA4 には届かない。イベント名はピクセルの EVENTS と揃える
  const BOOK = (location.pathname.match(/lookbook-([a-z]+)/) || [])[1] || 'unknown';
  const track = (name, data) => {
    try {
      window.Shopify?.analytics?.publish?.(`callec:${name}`, { book: BOOK, ...data });
    } catch (e) {
      console.warn('callec-lookbook: 計測を送れませんでした', name, e);
    }
  };
  // ルックが半分以上見えたら1回だけ送る。何ルック目まで見たか(読み進み)をこれで測る
  const watchLooks = (root, total) => {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        const key = en.target.dataset.clbOpen;
        track('lb_look_view', { look: key, index: key === 'cover' ? 0 : Number(key), total });
      });
    }, { threshold: 0.5 });
    root.querySelectorAll('.clb__cover[data-clb-open], .clb__look[data-clb-open]').forEach((el) => io.observe(el));
  };
  const init = (root) => {
    if (root.dataset.clbReady) return;
    root.dataset.clbReady = '1';
    const onTab = root.querySelector('.clb__tab.is-on');
    const tabs = root.querySelector('.clb__tabs');
    if (onTab && tabs) tabs.scrollLeft = onTab.offsetLeft - (tabs.clientWidth - onTab.offsetWidth) / 2;
    let data;
    try {
      data = JSON.parse(root.querySelector('[data-clb-data]').textContent);
    } catch (e) {
      console.error('callec-lookbook: データを読めませんでした', e);
      return;
    }
    const looks = data.looks.filter((l) => l.img);
    watchLooks(root, root.querySelectorAll('.clb__look[data-clb-open]').length);
    const modal = root.querySelector('[data-clb-modal]');
    const $ = (s) => modal.querySelector(s);
    const esc = (s) => String(s || '').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
    let cur = 0;
    let lastFocus = null;

    const render = () => {
      const l = looks[cur];
      const label = l.label === 'COVER' ? 'COVER' : String(l.label).padStart(2, '0');
      $('[data-clb-img]').src = l.img;
      $('[data-clb-img]').alt = `LOOK ${label}`;
      $('[data-clb-count]').textContent = `${cur + 1} / ${looks.length}`;
      $('[data-clb-cap]').textContent = l.label === 'COVER' ? 'STYLING' : `LOOK ${label}`;
      $('[data-clb-items]').innerHTML = l.items.map((it) => `
        <a class="clb-item" href="${esc(it.url)}">
          ${it.img ? `<img src="${esc(it.img)}" alt="" loading="lazy">` : '<span></span>'}
          <span><span class="clb-item__nm">${esc(it.title)}</span><span class="clb-item__sub">${esc([it.color, it.price].filter(Boolean).join(' ・ '))}</span></span>
          <span class="clb-item__go">見る</span>
        </a>`).join('');
    };
    const open = (key, from) => {
      const i = looks.findIndex((l) => String(l.key) === String(key));
      if (i < 0) return;
      track('lb_modal_open', { look: String(key), from });
      lastFocus = document.activeElement;
      cur = i;
      render();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      $('[data-clb-close]').focus();
    };
    const close = () => {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    };
    const step = (d) => {
      cur = (cur + d + looks.length) % looks.length;
      render();
      modal.querySelector('.clb-mdl__panel').scrollTop = 0;
    };

    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-clb-open]');
      if (t && !modal.contains(t)) {
        const from = t.classList.contains('clb__cover') ? 'cover' : t.classList.contains('clb__look') ? 'look' : 'index';
        open(t.dataset.clbOpen, from);
        return;
      }
      const a = e.target.closest('.clb__cta, .clb__next, .clb__tab');
      if (a) track('lb_cta_click', { target: a.classList.contains('clb__cta') ? 'collection' : a.classList.contains('clb__next') ? 'next' : 'tab', href: a.getAttribute('href') || '' });
    });
    $('[data-clb-items]').addEventListener('click', (e) => {
      const a = e.target.closest('a.clb-item');
      if (!a) return;
      const l = looks[cur];
      track('lb_item_click', { look: String(l.key), product: (a.getAttribute('href') || '').split('?')[0] });
    });
    root.querySelector('.clb__cover')?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open('cover', 'cover'); }
    });
    $('[data-clb-close]').addEventListener('click', close);
    $('[data-clb-prev]').addEventListener('click', () => step(-1));
    $('[data-clb-next]').addEventListener('click', () => step(1));
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') step(-1);
      if (e.key === 'ArrowRight') step(1);
    });
    let x0 = null;
    const media = $('[data-clb-media]');
    media.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    media.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
    });
  };

  const boot = () => document.querySelectorAll('[data-clb]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
